import React from 'react'
import { UserList } from '../../components/components'

function Explore() {
  return (
    <center className="col-12">
      <UserList />
    </center>
  )
}

export default Explore
